import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../recoil/userAtom";
import { readLastStep } from "../../../../utils/onboardingStorage";

export function OnboardingLoadV2() {
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  useEffect(() => {
    // LocalStorage에서 마지막 페이지 정보를 가져옵니다.
    const lastStep = readLastStep();

    // 마지막 페이지 정보가 있는지 확인합니다.
    if (lastStep && lastStep.type && lastStep.seqByType) {
      // 받아온 정보로 URL을 직접 만들어 바로 이동합니다.
      // URL의 유효성 검증 및 렌더링은 OnboardingScreen이 담당합니다.
      const url = lastStep.q
        ? `/onboarding_new/${lastStep.type}/${lastStep.seqByType}?q=${lastStep.q}`
        : `/onboarding_new/${lastStep.type}/${lastStep.seqByType}`;

      navigate(url, { replace: true });
    } else {
      // 마지막 페이지 정보가 없으면 (신규 유저), 온보딩 첫 단계로 이동합니다.
      if (user?.isWebFunnelRegister) {
        navigate("/onboarding_new/w2a-loading/1", { replace: true });
      } else {
        navigate("/onboarding_new/acquisition/1", { replace: true });
      }
    }
  }, [navigate, user]);

  // 리다이렉트 전에는 아무것도 렌더링하지 않습니다.
  return <></>;
}
